import KanbanBoard from "../Board/KanbanBoard";
import { useEffect, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import useStatuses from "../../hooks/useStatuses";
import useGlobalParams from "../../hooks/useGlobalParams";
import useLeadsKanban from "../../hooks/useLeads";
import LeadsMode from "../../common/Navigation/LeadsMode";

import './LeadsKanban.scss';

export default function LeadsKanban() {
  const queryClient = useQueryClient();
  const { categoryId } = useGlobalParams();

  const { data: leads, isLoading, /*isFetching, isError, error*/ } = useLeadsKanban({ categoryId, leadsPerStatus: 10, keepPreviousData: true, staleTime: Infinity, refetchOnWindowFocus: false });
  const { data: statuses } = useStatuses({ categoryId });

  useEffect(() => {
    return () => {
      queryClient.removeQueries(['leads-kanban', categoryId]);
      queryClient.removeQueries(['leads-status']);
    }
  }, [queryClient, categoryId])

  const kanbanItems = useMemo(() => {
    if (!statuses || !leads || statuses.length === 0) {
      return null;
    }
    
    const items = {};

    leads?.forEach(leadStatus => {
      items['status-' + leadStatus.status_id] = leadStatus.leads.map(lead => lead.id);
    });

    return items;
  }, [leads, statuses]);

  const initialLeads = useMemo(() => {
    const initialLeads = {};

    leads?.forEach(leadStatus => {
      initialLeads['status-' + leadStatus.status_id] = leadStatus.leads;
    });

    return initialLeads
  }, [leads]);

  const nextUrls = useMemo(() => {
    const urls = {};

    leads?.forEach(leadStatus => {
      urls['status-' + leadStatus.status_id] = leadStatus.next_link;
    });

    return urls;
  }, [leads]);

  const renderSkeletonColumn = () => (
    <div className="skeleton-column-container">
      <div className="skeleton-title" />
      <div className="skeleton-column">
        <div className="skeleton-item" />
        <div className="skeleton-item" />
        <div className="skeleton-item" />
      </div>
    </div>
  )

  const renderContent = () => {
    if (isLoading || kanbanItems === null) {
      return (
        <section className="skeleton-crew">
          { renderSkeletonColumn() }
          { renderSkeletonColumn() }
          { renderSkeletonColumn() }
          { renderSkeletonColumn() }
        </section>
      )
    }
    
    return <KanbanBoard key={categoryId} initialLeads={initialLeads} nextUrls={nextUrls} initialItems={kanbanItems} />
  }

  return (
    <section className='__leads-kanban'>
      <LeadsMode />
      { renderContent() }
    </section>
  )
}
